export default "__VITE_ASSET__DqQt49M6__"